<template>
  <BaseModal
    @close="close"
    class="modal-reset-password"
  >
    <div class="modal-container" :style="containerStyle">
      <div @click="close" class="icon icon-dc_phone_icon_all_close"></div>
      <div class="modal-logo"></div>
      <div class="modal-body">
        <ResetPasswordForm
          :error="error"
          @commit="commit"
          @signin="signin"
        ></ResetPasswordForm>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import env from '@/env.js'
import BaseModal from './BaseModal.vue'
import { ResetPasswordForm } from '../form'
export default {
  components: {
    BaseModal,
    ResetPasswordForm
  },
  props: {
    error: {
      default: null
    }
  },
  computed: {
    containerStyle () {
      if (!env.isMobile && this.error) {
        return `height: 440px`
      }
      return ''
    }
  },
  methods: {
    close () { this.$emit('close') },
    commit (input) { this.$emit('commit', input) },
    signin () { this.$emit('signin') }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.modal-reset-password {
  & .modal-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;

    background-color: var(--colorWhite);

    @media (--mediaPc) {
      height: 400px;
      width: 400px;
      border-radius: var(--borderRadius1);
    }
    @media (--mediaMobile) {
      height: 100%;
      width: 100%;
    }

    & .icon {
      position: absolute;
      cursor: pointer;
      right: 12px;
      top: 12px;
      color: var(--color6);
    }
    & .modal-logo {
      background-image: url('http://az.cdn.nutsbp.com/007/image/nuts_dartcome/phone/pr/cut_page/pr_phone_logo.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;

      width: 100%;
      @media (--mediaPc) {
        height: 66px;
        margin: 20px 0;
      }
      @media (--mediaMobile) {
        margin-top: calc(120px / var(--scaleMobile));
        height: calc(240px / var(--scaleMobile));
      }
    }
    & .modal-body {
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
      @media (--mediaPc) {
        top: 50%;
        padding-top: 66px;
      }
      @media (--mediaMobile) {
        top: 55%;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/modal/ResetPasswordModal.vue